import { typedRequest } from '../utils/httpClientTs';
import {
  ContactUsCategory,
  ContactUsRequest,
  ContactUsResponse,
} from '../types/feedback';

export const getContactUsCategories = async (): Promise<
  ContactUsCategory[]
> => {
  return typedRequest<ContactUsCategory[]>({
    url: '/feedback/contact_us_categories',
    method: 'GET',
  });
};

export const createContactUs = async (
  data: ContactUsRequest
): Promise<ContactUsResponse> => {
  return typedRequest<ContactUsResponse>({
    url: '/feedback/contact_us',
    method: 'POST',
    data: data,
  });
};
